module.exports = __webpack_public_path__ + "img/landing-logo-mobile-variant-B.f7d50d88.png";